/**
 * Общий Toaster приложения. KAN-834: в приложении менеджера (/m) снизу
 * нижние вкладки, поэтому тосты сверху по центру; в кабинете как раньше,
 * снизу справа. Должен стоять внутри BrowserRouter (берёт текущий путь).
 */
import { useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { isMobileAppPath } from '@/lib/mobileApp';

export function AppToaster(): JSX.Element {
  const { pathname } = useLocation();
  const mobile = isMobileAppPath(pathname);
  if (!mobile) return <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />;
  // Отступ под вырез экрана (safe-area), иначе тост уходит под часы и батарею.
  return (
    <Toaster
      position="top-center"
      offset="calc(env(safe-area-inset-top) + 12px)"
      toastOptions={{ duration: 4000 }}
    />
  );
}
